// Model Reducer
export const UPDATE_X = 'UPDATE_X';
export const UPDATE_MODEL = 'UPDATE_MODEL';
export const CLEAR_INPUT = 'CLEAR_INPUT';
export const RESET_RESULT = 'RESET_RESULT';
export const UPDATE_RESULT = 'UPDATE_RESULT';
export const PREDICT = 'PREDICT';
